import View from './routes/View.svelte';
import NotFound from './routes/NotFound.svelte';

export default {
    '/': View,
    // The catch-all route must always be last
    '*': NotFound
};
